import { useState, useCallback } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

const formatTimestamp = (value) => {
  if (!value) return value;
  if (value instanceof Date) return value.toISOString().slice(0, 19);
  if (Array.isArray(value) && value[0] instanceof Date) {
    return value[0].toISOString().slice(0, 19);
  }
  return value.length === 16 ? `${value}:00` : value;
};

const ScenariosLogsData = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async ({ scenarioId, fromTs, toTs }) => {
    if (!scenarioId || !fromTs || !toTs) {
      setError(t("scenarios.logs.missingParams"));
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(
        `https://toolbox.synchromode.eu/scenarios/${scenarioId}/logs`,
        {
          params: {
            from_ts: formatTimestamp(fromTs),
            to_ts: formatTimestamp(toTs),
          },
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      setData(response.data?.data || []);
    } catch (err) {
      setError(t("scenarios.logs.loadError"));
      setData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return { data, loading, error, fetchData };
};

export default ScenariosLogsData;
